import React from "react";

export function Spinner({ size = 24, color, className = "" }) {
  return (
    <span
      className={`inline-block animate-spin rounded-full border-[3px] border-current border-r-transparent ${color ? "" : "text-a-primary"} ${className}`}
      style={{ width: size, height: size, color }}
      role="status"
      aria-label="loading"
    />
  );
}

export function CenterSpinner() {
  return (
    <div className="flex justify-center py-10"><Spinner /></div>
  );
}
